import { createSlice } from "@reduxjs/toolkit";

import {
  CellNomenclatorInterface,
  CollectionErrorsInterface,
  MediGroupsInterface,
  MonthlyActivityWmsInterface,
  ProviderReceptionsInterface,
  UsersActivityDataInterface,
  UsersExtraActivitiesDataInterface,
} from "../interfaces/reports.interface";
import {
  getMediGroupsRaports,
  getMonthActivityWmsReports,
  getNomenclatorCelule,
  getProviderReceptionsRaports,
  getReturningProductsToProviderRaports,
  getUsersActivityReport,
  getUsersExtraActivities,
  postCollectionErrorsDetailed,
  postCollectionErrorsSimplified,
} from "../api/reports.api";
import { ReturningProductsToProviderReportsDataInterface } from "../interfaces/inventory.interface";

export const initialReportsState: {
  mediGroups: MediGroupsInterface;
  providerReceptions: ProviderReceptionsInterface;
  cellNomenclator: CellNomenclatorInterface;
  usersActivity: UsersActivityDataInterface;
  usersExtraActivities: UsersExtraActivitiesDataInterface;
  returningProductsToProvider: ReturningProductsToProviderReportsDataInterface;
  collectionErrorsSimplifed: CollectionErrorsInterface;
  collectionErrorsDetailed: CollectionErrorsInterface;
  monthActivityWmsReports: MonthlyActivityWmsInterface;
} = {
  mediGroups: {
    data: [],
    isLoadingMediGroups: true,
    isErrorMediGroups: false,
    errorMessageMediGroups: "",
  },
  providerReceptions: {
    data: [],
    isLoadingProviderReceptions: true,
    isErrorProviderReceptions: false,
    errorMessageProviderReceptions: "",
  },
  cellNomenclator: {
    data: [],
    isLoading: true,
    isError: false,
    errorMessage: "",
  },
  usersActivity: {
    data: {
      total: 1,
      data: [],
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  usersExtraActivities: {
    data: {
      total: 1,
      data: [],
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  returningProductsToProvider: {
    data: {
      total: 1,
      current_page: 1,
      data: [],
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  collectionErrorsSimplifed: {
    data: {
      total: 1,
      current_page: 1,
      data: [],
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  collectionErrorsDetailed: {
    data: {
      total: 1,
      current_page: 1,
      data: [],
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
  monthActivityWmsReports: {
    data: {
      total: 1,
      current_page: 1,
      data: [],
    },
    isLoading: false,
    isError: false,
    errorMessage: "",
  },
};

const reportsReducer = createSlice({
  name: "reports",
  initialState: initialReportsState,
  reducers: {
    clearUsersActivity(state) {
      return {
        ...state,
        usersActivity: initialReportsState.usersActivity,
      };
    },
    clearCollectionErrorsSimplified(state) {
      return {
        ...state,
        collectionErrorsSimplifed:
          initialReportsState.collectionErrorsSimplifed,
      };
    },
    clearCollectionErrorsDetailed(state) {
      return {
        ...state,
        collectionErrorsDetailed: initialReportsState.collectionErrorsDetailed,
      };
    },
    clearMonthlyActivityWmsReports(state) {
      return {
        ...state,
        monthActivityWmsReports: initialReportsState.monthActivityWmsReports,
      };
    },
  },
  extraReducers: (builder) => {
    // medi groups  raport start
    builder.addCase(getMediGroupsRaports.pending, (state) => {
      return {
        ...state,
        mediGroups: {
          ...initialReportsState.mediGroups,
          isLoadingMediGroups: true,
        },
      };
    });
    builder.addCase(getMediGroupsRaports.rejected, (state, action: any) => {
      return {
        ...state,
        mediGroups: {
          ...state.mediGroups,
          isLoadingMediGroups: false,
          errorMessageMediGroups: action.payload.message,
          isErrorMediGroups: true,
        },
      };
    });
    builder.addCase(getMediGroupsRaports.fulfilled, (state, action) => {
      return {
        ...state,
        mediGroups: {
          ...state.mediGroups,
          isLoadingMediGroups: false,
          data: action.payload,
        },
      };
    });
    // medi groups  raport end
    // provider receptions  raport start
    builder.addCase(getProviderReceptionsRaports.pending, (state) => {
      return {
        ...state,
        providerReceptions: {
          ...initialReportsState.providerReceptions,
          isLoadingProviderReceptions: true,
        },
      };
    });
    builder.addCase(
      getProviderReceptionsRaports.rejected,
      (state, action: any) => {
        return {
          ...state,
          providerReceptions: {
            ...state.providerReceptions,
            isLoadingProviderReceptions: false,
            errorMessageProviderReceptions: action.payload.message,
            isErrorProviderReceptions: true,
          },
        };
      },
    );
    builder.addCase(getProviderReceptionsRaports.fulfilled, (state, action) => {
      return {
        ...state,
        providerReceptions: {
          ...state.providerReceptions,
          isLoadingProviderReceptions: false,
          data: action.payload,
        },
      };
    });
    // provider receptions  raport end

    // getNomenclatorCelule start
    builder.addCase(getNomenclatorCelule.pending, (state) => {
      return {
        ...state,
        cellNomenclator: {
          ...initialReportsState.cellNomenclator,
          isLoading: true,
        },
      };
    });
    builder.addCase(getNomenclatorCelule.rejected, (state, action: any) => {
      return {
        ...state,
        cellNomenclator: {
          ...state.cellNomenclator,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getNomenclatorCelule.fulfilled, (state, action) => {
      return {
        ...state,
        cellNomenclator: {
          ...state.cellNomenclator,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // getNomenclatorCelule end
    // users activity raport start
    builder.addCase(getUsersActivityReport.pending, (state) => {
      return {
        ...state,
        usersActivity: {
          ...initialReportsState.usersActivity,
          isLoading: true,
        },
      };
    });
    builder.addCase(getUsersActivityReport.rejected, (state, action: any) => {
      return {
        ...state,
        usersActivity: {
          ...state.usersActivity,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getUsersActivityReport.fulfilled, (state, action) => {
      return {
        ...state,
        usersActivity: {
          ...state.usersActivity,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // users activity raport end

    // users extra activities raport start
    builder.addCase(getUsersExtraActivities.pending, (state) => {
      return {
        ...state,
        usersExtraActivities: {
          ...initialReportsState.usersExtraActivities,
          isLoading: true,
        },
      };
    });
    builder.addCase(getUsersExtraActivities.rejected, (state, action: any) => {
      return {
        ...state,
        usersExtraActivities: {
          ...state.usersExtraActivities,
          isLoading: false,
          errorMessage: action.payload.message,
          isError: true,
        },
      };
    });
    builder.addCase(getUsersExtraActivities.fulfilled, (state, action) => {
      return {
        ...state,
        usersExtraActivities: {
          ...state.usersExtraActivities,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // users extra activities raport end

    // returning products to provider start
    builder.addCase(getReturningProductsToProviderRaports.pending, (state) => {
      return {
        ...state,
        returningProductsToProvider: {
          ...initialReportsState.returningProductsToProvider,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      getReturningProductsToProviderRaports.rejected,
      (state, action: any) => {
        return {
          ...state,
          returningProductsToProvider: {
            ...state.returningProductsToProvider,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(
      getReturningProductsToProviderRaports.fulfilled,
      (state, action) => {
        return {
          ...state,
          returningProductsToProvider: {
            ...state.returningProductsToProvider,
            isLoading: false,
            data: action.payload,
          },
        };
      },
    );
    // returning products to provider end

    // collection errors simplified start
    builder.addCase(postCollectionErrorsSimplified.pending, (state) => {
      return {
        ...state,
        collectionErrorsSimplifed: {
          ...initialReportsState.collectionErrorsSimplifed,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      postCollectionErrorsSimplified.rejected,
      (state, action: any) => {
        return {
          ...state,
          collectionErrorsSimplifed: {
            ...state.collectionErrorsSimplifed,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(
      postCollectionErrorsSimplified.fulfilled,
      (state, action) => {
        return {
          ...state,
          collectionErrorsSimplifed: {
            ...state.collectionErrorsSimplifed,
            isLoading: false,
            data: action.payload,
          },
        };
      },
    );
    // collection errors simplified end

    // collection errors detailed start
    builder.addCase(postCollectionErrorsDetailed.pending, (state) => {
      return {
        ...state,
        collectionErrorsDetailed: {
          ...initialReportsState.collectionErrorsDetailed,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      postCollectionErrorsDetailed.rejected,
      (state, action: any) => {
        return {
          ...state,
          collectionErrorsDetailed: {
            ...state.collectionErrorsDetailed,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(postCollectionErrorsDetailed.fulfilled, (state, action) => {
      return {
        ...state,
        collectionErrorsDetailed: {
          ...state.collectionErrorsDetailed,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // collection errors end
    // month activity wms reports start
    builder.addCase(getMonthActivityWmsReports.pending, (state) => {
      return {
        ...state,
        monthActivityWmsReports: {
          ...initialReportsState.monthActivityWmsReports,
          isLoading: true,
        },
      };
    });
    builder.addCase(
      getMonthActivityWmsReports.rejected,
      (state, action: any) => {
        return {
          ...state,
          monthActivityWmsReports: {
            ...state.monthActivityWmsReports,
            isLoading: false,
            errorMessage: action.payload.message,
            isError: true,
          },
        };
      },
    );
    builder.addCase(getMonthActivityWmsReports.fulfilled, (state, action) => {
      return {
        ...state,
        monthActivityWmsReports: {
          ...state.monthActivityWmsReports,
          isLoading: false,
          data: action.payload,
        },
      };
    });
    // month activity wms reports end
  },
});

export const {
  clearUsersActivity,
  clearCollectionErrorsSimplified,
  clearCollectionErrorsDetailed,
  clearMonthlyActivityWmsReports,
} = reportsReducer.actions;

export default reportsReducer.reducer;
